import React from "react";
import { useI18n } from "../../lib/i18n.jsx";

/**
 * Franja de aval técnico.
 * Los cuatro sellos que sostienen la propuesta: quelatos, normativa,
 * pureza y compatibilidad ecológica. Sin prosa: el argumento de
 * síntoma-solución vive ahora en la sección de diagnóstico.
 */
export default function About() {
  const { t } = useI18n();

  const sellos = [
    { icon: "fa-atom", value: "EDTA · EDDHA", label: t.about.bullet1 },
    { icon: "fa-certificate", value: t.about.seal_eu, label: t.about.bullet4 },
    { icon: "fa-shield-halved", value: t.about.seal_metals, label: t.about.seal_metals_desc },
    { icon: "fa-leaf", value: t.about.seal_organic, label: t.about.bullet2 },
  ];

  return (
    <section
      id="nosotros"
      className="py-16 lg:py-20 bg-[#f7f7f4] border-y border-[#e5e8e2]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="eu-data-label mb-8 text-center">
          <i className="fa-solid fa-circle-nodes mr-2"></i>
          {t.about.eyebrow}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#e5e8e2] border border-[#e5e8e2]">
          {sellos.map((s, i) => (
            <div
              key={i}
              className="bg-[#f7f7f4] px-6 py-8 flex flex-col items-center text-center"
              data-testid={`about-seal-${i}`}
            >
              <i className={`fa-solid ${s.icon} text-[#b45f3e] text-xl mb-4`}></i>
              <div className="font-mono-eu text-sm font-bold text-[#133322] tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-xs text-[#5c6b61] leading-relaxed max-w-[22ch]">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-[#5c6b61] max-w-2xl mx-auto">
          {t.about.p2}
        </p>
      </div>
    </section>
  );
}
